<div #wrapper class="wrapper" [ngClass]="{ inactive: type === 'plain', center: !positionConfig  }">
  <div class="window" [txtbDraggable]="isDraggable"
       [ngClass]="{ inactive: type === 'plain', compact: ModalSize.COMPACT === size, positioned: !!positionConfig }"
       [style.--left]="positionConfig?.left" [style.--top]="positionConfig?.top" [style.--width]="positionConfig?.width"
       [style.--height]="positionConfig?.height">
    <div class="top" txtbDragHandle>
      <h2>{{ title }}</h2>
      <svg
        (click)="back()"
        width="20"
        preserveAspectRatio="xMidYMin"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 26.8 26.8"
      >
        <g>
          <path
            d="M0 4.15l9.25 9.25L0 22.65l4.15 4.15 9.25-9.25 9.25 9.25 4.15-4.15-9.25-9.25 9.25-9.25L22.65 0 13.4 9.25 4.15 0z"
            fill="#6d6d6d"
          />
        </g>
      </svg>
    </div>
    <div class="content">
      <ng-content select="[main]"></ng-content>
    </div>
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
